"use client";

import { percentage } from "@/utils/number";

type PercentageCellProps = {
  value: number | null | undefined;
  placeholder?: string;
};

/**
 * パーセント値セルを表示します。
 *
 * 比較テーブルでは `0` と欠損値の見分けが重要なため、
 * `null` / `undefined` は数値化せず placeholder を表示します。
 */
export const PercentageCell = ({
  value,
  placeholder = "-",
}: PercentageCellProps) => {
  if (value === null || typeof value === "undefined") {
    return (
      <div className="text-muted-foreground text-right font-mono tabular-nums">
        {placeholder}
      </div>
    );
  }
  return (
    <div className="text-right font-mono tabular-nums">{percentage(value)}</div>
  );
};
